import * as THREE from 'three';

// Loads what tools/build-startrails.mjs prepared for visualizers/startrails.js
// - the night arch photograph, the soft sky mask (lossless, 1.5 px edge) and
// the star catalogue (Float32: radius and angle around the pole, brightness,
// colour, rank) - ONCE, at startup. Same preload/get shape as
// stadium-assets.js, and the same rule: the preload is a WIRING POINT every
// entry point must call, and it resolves false when anything is missing so
// the entry point can withdraw Startrails from the rotation (no fallback: the
// visualizer IS the photograph and its sky).
const MANIFEST_URL = 'textures/startrails.json';

let _assets = null;
let _promise = null;

function loadTexture(url, configure) {
  return new Promise(function (resolve, reject) {
    new THREE.TextureLoader().load(url, function (t) { configure(t); t.needsUpdate = true; resolve(t); }, undefined, function () {
      reject(new Error(url + ' failed to load'));
    });
  });
}
function photo(t) {
  t.colorSpace = THREE.SRGBColorSpace;
  t.generateMipmaps = false;
  t.minFilter = THREE.LinearFilter;
  t.magFilter = THREE.LinearFilter;
  t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
}
// the sky mask is DATA (already softened at the build): linear, no colour
// space, no mipmaps
function mask(t) {
  t.colorSpace = THREE.NoColorSpace;
  t.generateMipmaps = false;
  t.minFilter = THREE.LinearFilter;
  t.magFilter = THREE.LinearFilter;
  t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
}

export function preloadStartrails() {
  if (_promise) return _promise.then(function (a) { return !!a; });
  _promise = fetch(MANIFEST_URL)
    .then(function (r) {
      if (!r.ok) throw new Error('startrails.json HTTP ' + r.status);
      return r.json();
    })
    .then(function (manifest) {
      return Promise.all([
        loadTexture('textures/' + manifest.photo, photo),
        loadTexture('textures/' + manifest.sky, mask),
        fetch('textures/' + manifest.starsBin).then(function (r) {
          if (!r.ok) throw new Error(manifest.starsBin + ' HTTP ' + r.status);
          return r.arrayBuffer();
        })
      ]).then(function (parts) {
        _assets = { manifest: manifest, photo: parts[0], sky: parts[1], stars: new Float32Array(parts[2]) };
        return _assets;
      });
    })
    .catch(function (err) {
      console.error('[party-mode] startrails assets unavailable, Startrails is withdrawn', err);
      _assets = null;
      return null;
    });
  return _promise.then(function (a) { return !!a; });
}

export function getStartrails() {
  return _assets;
}

// Node tests only: hand in assets without a fetch.
export function _setStartrailsForTests(a) { _assets = a; _promise = Promise.resolve(a); }
